export const daDataRequest = async (query, stateChanger) => {
    var url = "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/party";
    var token = "77ba3c43b3251b06f412b85aba31462916063f6c";

    var options = {
        method: "POST",
        mode: "cors",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": "Token " + token
        },
        body: JSON.stringify({query: query})
    }

    fetch(url, options)
        .then(response => response.json())
        .then(result => stateChanger(result.suggestions))
}